import { apiSlice } from '../../api/apiSlice';
import { GET_CORE_VALUES } from '../../constants';

export const CoreValueDropdownSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getCoreValues: builder.query({
            query: () => {
                return {
                    url: GET_CORE_VALUES,
                };
            },
        }),
    }),
});

export const { useGetCoreValuesQuery } = CoreValueDropdownSlice;
